<template>
    <v-card>
        <v-card-title>Verify SMS Number</v-card-title>

        <v-divider />

        <v-card-text>
            <div class="input-content" v-if="!verifyingCode && !verifySuccess && !verifyFailed">
                <span style="display: block;" class="mt-3 mb-3">
                    {{`Please enter the 6-digit verification code sent to ${number}. Didn't receive a code? Click`}} 
                    <span class="link" @click="startVerification(true)">here</span> to resend.
                    <span v-if="!resending">{{expTimerPretty}}</span>
                    <v-icon small v-if="resending">fas fa-spinner fa-spin</v-icon>
                </span>

                <div style="width: 100%; text-align: center; position: relative;">
                    <v-otp-input v-model="otpCode" :disabled="verifyingCode" @finish="verifyCode"></v-otp-input>
                    <v-btn class="mt-2 mb-1" color="#c42111" width="100%" @click="verifyCode" :disabled="otpCode.length != 6">verify code</v-btn>
                </div>
            </div>

            <div class="verifying-content" v-if="verifyingCode || verifySuccess || verifyFailed">
                <v-icon class="loader" v-if="verifyingCode">fas fa-spinner fa-spin</v-icon>
                <div class="verify-success" v-if="verifySuccess">
                    <v-icon class="mr-2" x-large color="#4caf50">mdi-check-circle</v-icon>
                    <span>Number Verified!</span>
                </div>
                <div class="verify-failed" v-if="verifyFailed">
                    <div style="display: inline-block"><v-icon class="mr-2" x-large color="#ff5252">mdi-alert</v-icon></div>
                    <div style="display: inline-block"><span>Invalid Code</span></div>
                </div>
            </div>

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'VerifySms',
    props: ['editUser'],
    components: {
    },
    data: () => ({
        otpCode: '',
        autoVerifyUsed: false,
        verifyingCode: false,
        verifySuccess: false,
        verifyFailed: false,
        resending: false,
        clockTickIntervalFunc: null,
        expTimerSec: 600,
        webappAuthKey: null
    }),

    computed: {
        number: function() {
            return this.$props.editUser.user_page_smpp;
        },

        expTimerPretty: function() {
            if(this.expTimerSec == null) {
                return null;
            }
            return (TELSA.moment("1900-01-01 00:00:00").add(this.expTimerSec, 'seconds').format("mm:ss"));
        },
    },

    methods: {
        startVerification: function(resend) {
            this.expTimerSec = 600;
            this.resending = resend;
            let route = 'https://page.telsasoft.com/api/v1/smsverification/start';
            return this.$http.post(route, {webapp_auth_key: this.webappAuthKey, number: this.number, customer: this.$store.state.batchConfig.licensee}).then(response => {
                this.resending = false;
                let result = response.body;
                document.getElementsByClassName('otp-field-box--0')[0].focus();
            });
        },

        verifyCode: function() {
            this.verifySuccess = false;
            this.verifyFailed = false;
            this.verifyingCode = true;
            let route = 'https://page.telsasoft.com/api/v1/smsverification/verify';
            return this.$http.post(route, {webapp_auth_key: this.webappAuthKey, number: this.number, customer: this.$store.state.batchConfig.licensee, code: this.otpCode, user_id: this.$props.editUser.user_id}).then(response => {
                let result = response.body;
                let self = this;
                if(result.includes('success')) {
                    let sRoute = (TELSA.apiHost + "verifysms/success");
                    return this.$http.post(sRoute, {args: {user_id: this.$props.editUser.user_id}}).then(response => {
                        this.verifyingCode = false;
                        this.verifySuccess = true;
                        setTimeout(function() {
                            self.$emit('success');
                        }, 1000);
                    }, error => {
                        this.verifyingCode = false;
                        self.$emit('cancel');
                    });
                }
                else {
                    this.verifyingCode = false;
                    this.verifyFailed = true;
                    setTimeout(function() {
                        self.verifyFailed = false;
                    }, 1000);
                }
            }, error => {
                this.verifyingCode = false;
            });
        },

        setupTimer: function() {
            let self = this;
            clearInterval(this.clockTickIntervalFunc);
            this.clockTickIntervalFunc = setInterval(function() {
                if(self.expTimerSec > 0) {
                    self.expTimerSec = (self.expTimerSec - 1);
                }
                else {
                    self.$emit('cancel');
                }
            }, 1000);
        },

        getWebappAuthKey: function() {
            let route = (TELSA.apiHost + "auth/keys");
            let args = {requested_keys: ['webapp_auth_key']}
            return this.$http.post(route, {args: args}).then(response => {
                let result = response.body;
                this.webappAuthKey = result.webapp_auth_key;
            });
        }
    },

    mounted() {
        this.getWebappAuthKey().then(r => {
            this.startVerification(false);
            this.setupTimer();
        });
    },

    destroyed() {
        clearInterval(this.clockTickIntervalFunc);
    },
  
};
</script>

<style scoped>

    .link {
        cursor: pointer;
        color: #c42111;
        text-decoration: underline;
        font-weight: bold;
    }

    .verifying-content {
        width: 100%;
        text-align: center;        
        height: 200px;
    }
    .verifying-content .loader {
        font-size: 6em;
        margin-top: 25%;
    }

    .verify-success, .verify-failed {
        text-align: center;
        margin-top: 0px;
        font-size: 2.2em;
        padding-top: 25%;
    }
    .verify-success span {
        color: #4caf50;
        vertical-align: middle;
    }
    .verify-failed span {
        color: #ff5252;
        vertical-align: middle;
    }

    @media(max-width: 600px) {
        .verify-success, .verify-failed {
            font-size: 1.75em;
        }
    }

</style>

